/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Queue_Inbounds_To_CaptureInputs */

const en_queue_inbounds_to_capture = /** @type {(inputs: Queue_Inbounds_To_CaptureInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Inbounds with a packing list to type`)
};

/**
* | output |
* | --- |
* | "Inbounds with a packing list to type" |
*
* @param {Queue_Inbounds_To_CaptureInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const queue_inbounds_to_capture = /** @type {((inputs?: Queue_Inbounds_To_CaptureInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Queue_Inbounds_To_CaptureInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_queue_inbounds_to_capture(inputs)
});